module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-scroller d-flex align-items-center m-3"
  }, [_c('span', {
    on: {
      "click": _vm.scrollLeft
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "track relative"
  }, [_c('ul', {
    ref: "periods",
    staticClass: "relative d-flex",
    attrs: {
      "id": "scroller-time"
    }
  }, _vm._l((_vm.periods), function(period) {
    return _c('li', {
      class: {
        selected: _vm.isSelected(period),
        bold: _vm.isSelected(period)
      },
      on: {
        "click": _vm.select
      }
    }, [_vm._v("\n                " + _vm._s(period) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('span', {
    staticClass: "ml-auto",
    on: {
      "click": _vm.scrollRight
    }
  }, [_c('i', {
    staticClass: "ico-arrow-right"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a65d006"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/TimelineScroller.vue
// module id = 1538
// module chunks = 0